import type { VAxios } from '../../define/axios/Axios';
import {
  IListComplexOrgsRes,
  IsInOrgRes,
  IMemberjoinByExcelImportRes,
  ICheckInviteCodeRes,
  IMemberJoinByInviteCodeParams,
  IMemberJoinByInviteCodeRes,
  IListMembersParams,
  IListMembersRes,
  IMemberJoinByMobileParams,
  IMemberJoinByMobileRes,
  CreateOrgParams,
  CreateOrgRes,
  CreatePersonalParams,
  CreatePersonalRes,
  UpdateUserRoleParams,
  OrgListRes,
  TryAddMemberParams,
  TryAddMemberRes,
  CurrentOrgRes,
  RolesRes,
} from '../../entities/ems/index.entities';

export const createApi = (defHttp: VAxios) => ({
  // 当前租户信息
  getOrgCurrent: (): Promise<CurrentOrgRes> => {
    return defHttp.get<CurrentOrgRes>({
      url: `/aiad/ems/orgs/current`,
    });
  },

  // 租户列表复杂信息
  listComplexOrgs: (): Promise<IListComplexOrgsRes> => {
    return defHttp.get<IListComplexOrgsRes>({
      url: `/aiad/ems/complex-orgs`,
    });
  },

  // 判断用户是否在指定租户里
  isInOrg: (params: { orgId: string }): Promise<IsInOrgRes> => {
    return defHttp.get<IsInOrgRes>({
      url: `/aiad/ems/contains`,
      params,
    });
  },

  // 通过文件导入添加成员
  memberJoinByExcelImport: (params: { file: FormData }): Promise<IMemberjoinByExcelImportRes> => {
    return defHttp.post<IMemberjoinByExcelImportRes>({
      url: `/aiad/ems/import-join`,
      params,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // 检查邀请码
  checkInviteCode: (params: { invite: string }): Promise<ICheckInviteCodeRes> => {
    return defHttp.get<ICheckInviteCodeRes>({
      url: `/aiad/ems/invite`,
      params,
    });
  },

  // 获取邀请码
  inviteCode: (params: { expiresIn: number; roleCode: string }): Promise<string> => {
    return defHttp.post<string>({
      url: `/aiad/ems/invite`,
      params,
    });
  },

  // 通过邀请码添加成员
  memberJoinByInviteCode: (
    params: IMemberJoinByInviteCodeParams
  ): Promise<IMemberJoinByInviteCodeRes> => {
    return defHttp.post<IMemberJoinByInviteCodeRes>({
      url: `/aiad/ems/invite-join`,
      params,
    });
  },

  // 成员列表接口
  listMembers: (params: IListMembersParams): Promise<IListMembersRes> => {
    return defHttp.get<IListMembersRes>({
      url: `/aiad/ems/members`,
      params,
    });
  },

  // 修改用户在团队中的昵称或职位
  updateOrgMember: (params: {
    memberName?: string;
    orgId: string;
    position?: string;
  }): Promise<IListMembersRes> => {
    return defHttp.put({
      url: `/aiad/ems/members`,
      params,
    });
  },

  // 管理员修改团队成员昵称
  updateMemberName: (params: { memberName?: string; userId: number }): Promise<IListMembersRes> => {
    return defHttp.put({
      url: `/aiad/ems/members/name`,
      params,
    });
  },

  // 通过手机号添加成员
  memberJoinByMobile: (params: IMemberJoinByMobileParams[]): Promise<IMemberJoinByMobileRes> => {
    return defHttp.post<IMemberJoinByMobileRes>({
      url: `/aiad/ems/mobile-join`,
      params,
    });
  },

  // 创建团队组织
  createOrg: (params: CreateOrgParams): Promise<CreateOrgRes> => {
    return defHttp.post<CreateOrgRes>({
      url: `/aiad/ems/org`,
      params,
    });
  },

  // 创建pod团队组织
  createPodOrg: (params: CreateOrgParams): Promise<CreateOrgRes> => {
    return defHttp.post<CreateOrgRes>({
      url: `/aiad/ems/org/pod`,
      params,
    });
  },

  // 创建个人组织
  createPersonal: (params: CreatePersonalParams): Promise<CreatePersonalRes> => {
    return defHttp.post<CreatePersonalRes>({
      url: `/aiad/ems/personal`,
      params,
    });
  },

  // 成员退出组织
  memberQuit: () => {
    return defHttp.delete({
      url: `/aiad/ems/quit`,
    });
  },

  // 管理员移除成员
  removeMember: (params: { userId: string }) => {
    return defHttp.delete({
      url: `/aiad/ems/remove`,
      params,
    });
  },

  // 修改成员角色
  updateUserRole: (params: UpdateUserRoleParams) => {
    return defHttp.put({
      url: `/aiad/ems/roles`,
      params,
    });
  },

  // 我的组织列表简单信息
  list: (): Promise<OrgListRes> => {
    return defHttp.get<OrgListRes>({
      url: `/aiad/ems/simple-orgs`,
    });
  },

  // 通过手机号预预添加成员-校验和自动注册
  tryAddMember: (params: TryAddMemberParams): Promise<TryAddMemberRes> => {
    return defHttp.post<TryAddMemberRes>({
      url: `/aiad/ems/mobile-join-check`,
      params,
    });
  },

  // 修改组织信息
  updateOrgInfo: (params: { industry?: string; logo?: string; name?: string }) => {
    return defHttp.put({
      url: `/aiad/ems/orgs/current`,
      params,
    });
  },

  // 获取角色列表
  roles: () => {
    return defHttp.get<RolesRes[]>({
      url: `/aiad/ems/roles`,
    });
  },

  // 获取当前画布审核状态
  getCanvasStatus: () => {
    return defHttp.get<0 | 1 | 2>({
      url: `/aiad/ems/canvas`,
    });
  },

  // 申请ip增强
  applyIpEnhance: (params) => {
    return defHttp.post({
      url: `/aiad/ems/ip-enhance-apply`,
      params,
    });
  },

  // 查询ip增强申请状态
  getIpEnhanceStatus: () => {
    return defHttp.get({
      url: `/aiad/ems/ip-enhance-apply`,
    });
  },

  // 设置成员类目
  setMemberCategory(params: { category: string }) {
    return defHttp.put({ url: `/aiad/ems/member/category`, params });
  },
});
